import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap'
import img19 from "../Assets/images/Group102.png"
import img20 from "../Assets/images/Group103.png"
import img23 from "../Assets/images/Frame 98.png"
import { useTranslation } from 'react-i18next';
import headerImg from "../Assets/images/Group 1145.png"
import ProgramHighlights from '../Components/programHighlights/ProgramHighlights';
import duration from "../Assets/images/duration.png";
import format from "../Assets/images/format.png";
import level from "../Assets/images/levels.png";
import certification from "../Assets/images/certification.png";
import whatYouGetImg from "../Assets/images/wul5.png"
import WhatYouGetSection from '../Components/whatYouGetSection/WhatYouGetSection';
import WhoThisProgramIsFor from '../Components/WhoThisProgramIsFor/WhoThisProgramIsFor';
import img26 from "../Assets/images/1.png";
import img27 from "../Assets/images/7.png";
import img28 from "../Assets/images/20.png";
import img29 from "../Assets/images/18.png";
import img30 from "../Assets/images/4.png";
import { Modal } from 'antd';
import RegistrationPopup from '../Components/registrationPopUp/RegistrationPopup';

function ArabicCalligraphy() {

    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);


 const cardsData = [
        { title: t("duration"), details: t("arabic_calligraphy_cardData.duration_details"), img: duration },
        { title: t("format"), details: t("arabic_calligraphy_cardData.format_details"), img: format },
        { title: t("level"), details: t("arabic_calligraphy_cardData.level_details"), img: level },
        { title: t("certification"), details: t("arabic_calligraphy_cardData.certification_details"), img: certification },
    ];
    const whatYouGetData = [
        { description: t("training_naskh_ruqah") },
        { description: t("stroke_techniques") },
        { description: t("student_teacher_books") },
        { description: t("digital_platform_with_guided_tutorials") },
        { description: t("skill_progression") },
    ]
    const whatProgramFor = [
        { img: img27, title: t("beginners"), desc: t("beginners_desc") },
        { img: img26, title: t("students"), desc: t("students_calligraphy_desc") },
        { img: img28, title: t("designers"), desc: t("designers_desc") },
        { img: img29, title: t("artists"), desc: t("artists_desc") },
        { img: img30, title: t("cultural_enthusiasts"), desc: t("cultural_enthusiasts_calligraphy_desc") },
    ];
    return (
        <div className='arabicCalligraphy'>
            <section className='arabicLife-sec'>
                <div className='first-section position-relative'>
                    <Row className='justify-content-start flex-column gx-0'>
                        <Col md={12} className='content-box'>
                            <Container>
                                <h2 className='mb-3' style={{ marginTop: "150px" }}>{t("arabic_calligraphy")}</h2>
                                <h5 className='mb-4'>
                                    {t("arabic_calligraphy_subtitle")}
                                </h5>

                            </Container>
                        </Col>

                    </Row>
                    <Row className='justify-content-start flex-column '>
                        <Col md={12} className='green-div'>
                            <div className='ap-second-section d-flex justify-content-start px-5 align-items-center '>
                                <Container>   <button className='btn fw-bold' onClick={() => setIsModalOpen(true)}>  {t("start_now")}</button></Container>

                            </div>


                        </Col>

                    </Row>
                    <img src={headerImg} alt='' className='ar-life-logo' />
                </div>
            </section>

            <section>
                <Container>
                    <ProgramHighlights cardsData={cardsData} color='#5AC4C859' />
                    <WhatYouGetSection data={whatYouGetData} img={whatYouGetImg} />
                </Container>
            </section>

            <section className='my-5'>
                <WhoThisProgramIsFor data={whatProgramFor} />
            </section>

            <div className='fourth-section mt-5'>
                <Container className='mt-5  '>
                    <div className='relative-sec'>
                        <Row>
                            <Col md={3} >
                                <img src={img20} alt='' className='books-items-position' />
                            </Col>
                            <Col md={9} className='d-flex align-items-start smoky-yellow-sec' style={{ padding: "60px 70px" }}>
                                <div className='card_text'>
                                  <h6>{t("naskh_course_title")}</h6>
<p>{t("naskh_course_description")}</p>


                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className='relative-sec'>
                        <Row>
                            <Col md={9} className='d-flex align-items-start smoky-yellow-sec' style={{ padding: "60px 70px" }}>
                                <div>
                                  <h6>{t("ruqah_course_title")}</h6>
<p>{t("ruqah_course_description")}</p>

                                </div>
                            </Col>
                            <Col md={3} >
                                <img src={img19} alt='' className='books-items-position2' />
                            </Col>
                        </Row>
                    </div>



                </Container>
            </div>

            <div className='last-sec'>
                <Container>
                    <Row className='align-items-center'>
                        <Col md={7}>
                            <h6> {t("arabic_calligraphy_program")} </h6>
                            <p> {t("final_call")} </p>
                            <button onClick={() => setIsModalOpen(true)}> {t("register_now")} </button>
                        </Col>
                        <Col md={5}>
                            <img src={img23} alt='' className='w-100' />
                        </Col>
                    </Row>
                </Container>
            </div>
            <Modal
                open={isModalOpen}
                footer={null}
                destroyOnClose
                onCancel={() => setIsModalOpen(false)}
                width={"80vw"} // close handler
            >
                <RegistrationPopup setIsModalOpen={setIsModalOpen} />
            </Modal>
        </div>

    )
}

export default ArabicCalligraphy
